
import { defineComponent } from 'vue'
import * as echarts from 'echarts'
import { ElMessage } from 'element-plus'
import { queryStaffRecordListApi, insuranceAxTransfer, insuranceAxRecharge, getRealTimeDataApi, addEnsureProject, switchEnsureProjectApi, getEnsureProjectListApi, getPremiumAndInsureNumApi, getInsureEnsurePlanApi, getPremiumAndInsureNumEchartsApi, getAxDailyBalanceApi, getInsureBalanceAxPermission, getNowProjectIdApi } from '@/api/insure-daily-ax'
import { queryListByEnterApi, queryInsureCompanyRateStatus } from '../api/long-insure-new'
import popupRecharge from '@/components/insure-daily-ax/popup-recharge.vue'
import feeRateNotice from '@/components/dialog/fee-rate-notice.vue'
import addInsure from '@/components/insure-daily-ax/add-insure.vue'
import { getqueryreceiptaccountapi } from '@/api/base'
import { wxUuid, shake } from '@/utils/util'
import clipboard from 'clipboard'
import { formatter, filterIdCard } from '../utils/util'
import { policyStatusList } from '../utils/insure-daily-ax-dict'
import user from '@/utils/user'

import dayjs from 'dayjs'

export default defineComponent({
  name: 'InsureDailyAX',
  components: {
    popupRecharge,
    addInsure,
    feeRateNotice
  },
  data() {
    return {
      formatter,
      filterIdCard,
      policyStatusList,
      projectId: '',
      projectName: '',
      realTimeData: {} as {
        premium: number
        premiumPercent: number
        insureNum: number
        insureNumPercent: number
      }, // 实时数据
      premiumAndInsureData: {} as {
        caseCount: number
        finalMoney: number
        claimRate: number
        feeRate: number
      }, // 风险分析
      bankInfo: {} as {
        bankName: string
        openBank: string
        bankNo: string
      },
      tableData: [],
      selects: [],
      formSearch: {
        searchUserInfo: '',
        userName: '',
        userID: '',
        planId: '',
        date: '',
        policyStatus: ''
      },
      renewalManufactory: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      balance: '',
      isRecharge: false, // 充值
      isTransfer: false, // 转账
      transferNum: '',
      isAddInsure: false, // 加保
      projectShow: false, // 切换 项目
      addProjectShow: false, // 添加项目
      projectList: [],
      formAddProject: {
        name: ''
      },
      addProjectRules: {
        name: [{ required: true, message: '此项必填', trigger: 'blur' }]
      },
      isAddInsureDrawer: false,
      addInsureRules: {
        planCode: [{ required: true, message: '此项必填', trigger: 'blur' }],
        companyId: [{ required: true, message: '此项必填', trigger: 'blur' }],
        workType: [{ required: true, message: '此项必填', trigger: 'blur' }],
        date: [{ required: true, message: '此项必填', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      formAddInsure: {
        planCode: '',
        companyId: '',
        workType: '',
        date: ''
      },
      isOpenWesure: '',
      baseInfo: {},
      planList: [],
      planSearchList: [],
      companyList: [],
      workTypeList: [],
      showNotice: true,
      showInsureRate: false,
      titleTip: '通知',
      increaseData: {} as {}
    }
  },

  async created() {
    this.showNotice = true
    this.initShowInsureCompanyRate()
    // 获取几个折线图数据 && 风险分析 仪表盘
    this.initPremiumData()
    // 获取实时数据
    this.getRealTimeData()
    // 查询公司安心日保余额
    this.getInsureBalance()
    // 银行账户信息
    this.getBankAccountInfo()
    // 获取方案列表
    this.getPlanList()
    // 获取充值权限
    this.getInsureBalancePermission()
    // 获取当前项目id 再获取分页数据
    await this.getNowProjectId()
    // 获取tableList
    this.initTableList()
  },
  methods: {
    //  保费上调 or 下降通知 （当前企业）
    async initShowInsureCompanyRate() {
      const res = await queryInsureCompanyRateStatus({ productType: 8 })
      if (!res.showToastWindow) return
      let titleTip = res.changeState === 1 ? '您的保费费率已下调' : res.changeState === 0 ? '您的保费费率已上涨' : '通知'

      this.increaseData = res
      this.titleTip = titleTip

      const companyId = user.companyId || ''
      const userId = user.userId || ''
      const storageKey = `up_rate_pop_${companyId}_${userId}`
      // 缓存上一次的涨幅率
      const dailyIncreaseRateKey = `dailyIncreaseRate_${companyId}_${userId}`
      const dailyIncreaseRate = localStorage.getItem(dailyIncreaseRateKey)
      // 缓存上一次的关闭时间
      const insureCloseData = localStorage.getItem(storageKey)
      if (!insureCloseData) {
        // 拿不到上一次的关闭时间 第一次弹
        console.log('第一次弹', !insureCloseData)
        this.showInsureRate = true
      }
      // 拿到上一次的涨幅率，跟本次的对比，如果两次不一样，显示弹框 并写入本次涨幅率
      if (res.increaseRate != Number(dailyIncreaseRate)) {
        console.log('拿到上一次的涨幅率，跟本次的对比', res.increaseRate, dailyIncreaseRate)
        this.showInsureRate = true
        return
      }
    },
    closeInsureCompanyRate() {
      // 关闭 我知道后 缓存key：
      const curStamp = dayjs().format('YYYY-MM-DD')
      const companyId = user.companyId || ''
      const userId = user.userId || ''
      const storageKey = `up_rate_pop_${companyId}_${userId}`
      const dailyIncreaseRateKey = `dailyIncreaseRate_${companyId}_${userId}`
      localStorage.setItem(storageKey, curStamp)

      localStorage.setItem(dailyIncreaseRateKey, this.increaseData.increaseRate)
      this.showInsureRate = false
    },
    // 转账
    onTransfer() {
      // 必须管理员操作，且安心保 安心日保 的充值帐户相同
      // if(){}
      this.isTransfer = true
    },
    onCloseTransfer() {
      this.transferNum = ' '
      this.isTransfer = false
    },
    // 微信充值 手动输入 充值金额
    onChangeNum(event: string) {
      if (this.transferNum.length === 0) {
        this.$message.error('请输入内容')
        return
      }
      if (Number(this.transferNum) < 0) {
        this.$message.error('输入金额不可小于0元')
        return
      }
      shake((): any => {
        console.log('发起请求')
        this.transferNum = this.transferNum
          .replace(/[^\d.]/g, '') // 移除非数字和非小数点
          .replace(/\.{2,}/g, '.') // 只保留第一个点，移除多余的点
          .replace(/(\..*)\./g, '$1') // 确保只有一个小数点
      }, 1000)
    },
    // 转账 转出  安心日保 转出到安心保
    async onSaveTransfer() {
      const res = await insuranceAxTransfer({
        requestId: wxUuid(),
        rechargeAmount: this.transferNum
      })
      console.log(res, '确定转出 res')
      ElMessage.success('转出成功')
      this.getInsureBalance()
      this.onCloseTransfer()
    },
    // 获取充值权限
    async getInsureBalancePermission() {
      const result = await getInsureBalanceAxPermission()
      this.isOpenWesure = result.isOpenWesure
      console.log(result, '获取充值权限')
    },

    // 充值
    onRecharge() {
      if (this.isOpenWesure === 1) {
        this.isRecharge = true
        console.log('打开 充值弹框')
      } else {
        ElMessage({
          type: 'warning',
          message: '温馨提示：您还没有开通该功能权限，如有需要请联系销售'
        })
      }
    },

    // 复制账户信息
    onCopyText() {
      let text = `企业全称：${this.bankInfo.bankName};银行账号：${this.bankInfo.bankNo};开户行：${this.bankInfo.openBank}`
      clipboard.copy(text)
      ElMessage.success('复制成功')
    },
    // 关闭充值弹框
    onCloseRecharge() {
      this.isRecharge = false
    },
    // 确定 提交充值弹框
    async onSaveRecharge(num: string, ocrNum: string, ocrImg: string, isRepeat: boolean) {
      if (!num) {
        this.$message.error('请输入金额')
        return
      }
      if (!ocrImg) {
        this.$message.error('请上传凭证')
        return
      }
      const result = await insuranceAxRecharge({
        rechargeAmount: num,
        ocrAmount: ocrNum,
        voucherUrl: ocrImg,
        receiptId: user.receiptId,
        isRepeat: isRepeat,
        requestId: wxUuid()
      })
      if (result) {
        // this.isRecharge = false
        this.$message.success('提交成功')
        if (result.msg === '审核中') {
          this.$refs.rechargeRef.typeIndex = 0
        } else if (result.msg === '薪福通快速审核通过') {
          this.$refs.rechargeRef.typeIndex = 1
        }
        console.log(2121, this.$refs.rechargeRef.typeIndex)
      }
    },
    // 切换项目
    async onChangeProject() {
      // 获取最新项目列表
      await this.getProjectList()
      this.projectShow = true
    },
    // 创建项目
    onAddProject() {
      this.addProjectShow = true
    },
    onCloseProject() {
      this.projectShow = false
    },
    onCloseAddProject() {
      this.addProjectShow = false
    },
    async onUseProject(item) {
      console.log(item, '使用当前选中的项目')
      const res = await switchEnsureProjectApi({
        platformCode: 1, //（1:PC B端  2:微信B端）
        insureType: 8, // 保险产品（ 2:长期保  8:安心日保）
        projectId: item.projectId
      })
      ElMessage.success('切换项目成功')
      this.projectShow = false
      this.projectId = item.projectId
      this.projectName = item.name
      this.initTableList()
    },
    async onSaveAddProject() {
      console.log(this.formAddProject.name)
      ;(this.$refs.addProject as any).validate(async (valid: any) => {
        if (valid) {
          const res = await addEnsureProject({
            platformCode: 1, //（1:PC B端  2:微信B端）
            insureType: 8, // 保险产品（ 2:长期保  8:安心日保）
            name: this.formAddProject.name
          })
          ElMessage.success('添加项目成功')
          this.getProjectList()
          this.addProjectShow = false
        } else {
        }
      })
    },

    handleDisableDate(time) {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0)

      const lastAvailableDay = new Date()
      lastAvailableDay.setDate(tomorrow.getDate() + 6)
      lastAvailableDay.setHours(23, 59, 59, 999)
      return time.getTime() < tomorrow.getTime() || time.getTime() > lastAvailableDay.getTime()
    },
    /*？
        vue 项目 <el-date-picker   默认为明天
        */
    //  晚上23:55:00 - 23:59:59秒这段时间，按钮置灰，不能操作加保
    onAddInsure() {
      const now = new Date()
      const today = now.getDate()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const seconds = now.getSeconds()

      const isArrow = hours === 23 && minutes >= 55 && (minutes < 59 || (minutes === 59 && seconds <= 59))
      // console.log(hours === 23 && minutes >= 55 && (minutes < 59 || (minutes === 59 && seconds <= 59)))
      // console.log( hours === 15 && minutes >= 43 && (minutes < 55 || (minutes === 55 && seconds <= 59)) )

      if (isArrow) {
        ElMessage({
          type: 'warning',
          message: '温馨提示：23:55:00 - 23:59:59 这段时间不能操作加保'
        })
        return
      } else {
        this.formAddInsure.date = dayjs().add(1, 'day').format('YYYY-MM-DD')
        this.isAddInsure = true
      }
    },
    // 关闭加保抽屉 刷新页面数据
    async onCloseDrawer(val) {
      console.log(val)

      this.onCloseAddInsure()
      this.isAddInsureDrawer = val
      this.onReset()
      // 获取几个折线图数据 && 风险分析 仪表盘
      this.initPremiumData()
      // 获取实时数据
      this.getRealTimeData()
      // 查询公司安心日保余额
      this.getInsureBalance()
      this.initTableList()
    },

    // 加保
    onCloseAddInsure() {
      ;(this.$refs.ruleAddInsureRef as any).resetFields()
      this.isAddInsure = false
    },
    async onSaveAddInsure() {
      ;(this.$refs.ruleAddInsureRef as any).validate((valid: any) => {
        if (valid) {
          this.baseInfo = { ...this.formAddInsure }
          console.log(this.baseInfo, '打开加保抽屉')
          this.isAddInsureDrawer = true
        } else {
        }
      })
    },

    // 点击应用模块
    onModuleClick(type: string) {
      switch (type) {
        case 'company':
          console.log('跳转 派遣单位')
          this.$router.push({
            path: '/insure-daily-company'
          })

          break
        case 'helpClaim':
          console.log('跳转 协助理赔')
          this.$router.push({
            path: '/insure-daily-claim'
          })

          break
        case 'insureValue':
          console.log('跳转 保费记录')
          this.$router.push({
            path: '/insure-daily-premium-record'
          })
          break
        case 'billInfo':
          console.log('跳转 账单明细')
          this.$router.push({
            path: '/insure-daily-bill-info'
          })

          break
        case 'operateRecord':
          console.log('跳转 操作记录')
          this.$router.push({
            path: '/insure-daily-operate-record'
          })
          break
        case 'insurePlan':
          console.log('跳转 保司方案')
          this.$router.push({
            path: '/insure-daily-plan',
            query: {
              insureType: 8
            }
          })

          break
      }
    },

    onSearch() {
      console.log('onSearch')
      this.pageNum = 1
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        searchUserInfo: '',
        planId: '',
        date: '',
        policyStatus: ''
      }
      this.onSearch()
    },
    rowKeyInit(row: any) {
      return row.id
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },

    // 初始化 获取几个折线图数据
    async initPremiumData() {
      const res = await getPremiumAndInsureNumEchartsApi({ insureType: 8 })

      // 获取风险分析
      const result: any = await getPremiumAndInsureNumApi()

      const dom1 = document.getElementById('premium') as HTMLElement
      const dom2 = document.getElementById('insureNum') as HTMLElement
      const riskDom = document.getElementById('riskAnalysis') as HTMLElement

      // echarts.dispose(dom1)
      // echarts.dispose(dom2)
      const charts1 = echarts.init(dom1)
      const charts2 = echarts.init(dom2)
      const riskCharts = echarts.init(riskDom)

      // const value1 = 100 - (100 * (Number((result.claimRateNum * 100).toFixed(2)) >= 140 ? 140 : Number((result.claimRateNum * 100).toFixed(2)))) / 140
      // const value2 = 98 - (100 * (Number((result.claimRateNum * 100).toFixed(2)) >= 140 ? 140 : Number((result.claimRateNum * 100).toFixed(2)))) / 140 == 98 ? 100 : 98 - (100 * (Number((result.claimRateNum * 100).toFixed(2)) >= 140 ? 140 : Number((result.claimRateNum * 100).toFixed(2)))) / 140
      // const value1 = result.claimRateNum
      // const value2 = result.claimRateNum
      // const value1 = 100 - result.claimRateNum
      // const value2 = 98 - result.claimRateNum
      // const value1 = 100 - (result.claimRateNum >= 140 ? 140 : result.claimRateNum)
      // const value2 = 98 - result.claimRateNum == 98 ? 100 : 98 - result.claimRateNum
      const value1 = 100 - (100 * (result.claimRateNum.toFixed(2) >= 140 ? 140 : result.claimRateNum.toFixed(2))) / 140
      const value2 = 98 - (100 * (result.claimRateNum.toFixed(2) >= 140 ? 140 : result.claimRateNum.toFixed(2))) / 140 == 98 ? 100 : 98 - (100 * (result.claimRateNum.toFixed(2) >= 140 ? 140 : result.claimRateNum.toFixed(2))) / 140

      this.premiumAndInsureData = result

      setTimeout(() => {
        const option1 = {
          tooltip: {
            axisPointer: {
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '10px',
            right: '10px',
            top: '10px',
            bottom: '10px',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.map((item) => item.day)
          },
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'line',
              areaStyle: {},
              data: res.map((item) => item.premium)
            }
          ]
        }
        const option2 = {
          tooltip: {
            axisPointer: {
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '10px',
            right: '10px',
            top: '10px',
            bottom: '10px',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.map((item) => item.day)
          },
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'line',
              areaStyle: {},
              data: res.map((item) => item.insureNum)
            }
          ]
        }

        const riskOption = {
          series: [
            {
              type: 'gauge',
              radius: '95%',
              center: ['50%', '80%'],
              startAngle: 180,
              endAngle: 0,
              min: 0,
              max: 100,
              splitNumber: 20,
              padding: 0,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#FF7E68' // 0% 处的颜色
                    },
                    {
                      offset: 0.25,
                      color: '#FF9444' // 100% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#FFC53D' // 100% 处的颜色
                    },
                    {
                      offset: 0.75,
                      color: '#B0ED00' // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#00D679' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              yAxis: {
                padding: 0
              },
              xAxis: {
                padding: 0
              },
              progress: {
                show: true,
                width: 20
              },
              pointer: {
                // icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
                show: false,
                length: '100',
                offsetCenter: [0, 0],
                itemStyle: {
                  color: 'auto'
                }
              },
              axisLine: {
                lineStyle: {
                  width: 25,
                  color: [
                    [
                      1,
                      new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        {
                          offset: 0.3,
                          color: 'rgba(255, 129, 114, 0.1)'
                        },
                        {
                          offset: 0.7,
                          color: 'rgba(255, 197, 61, 0.1)'
                        },
                        {
                          offset: 1,
                          color: 'rgba(115, 222, 179, 0.1)'
                        }
                      ])
                    ]
                  ]
                }
              },
              axisTick: {
                distance: -40,
                splitNumber: 5,
                lineStyle: {
                  width: 2,
                  height: 2,
                  color: '#FFF3E1'
                }
              },
              splitLine: {
                distance: -45,
                length: 14,
                show: false,
                lineStyle: {
                  width: 3,
                  height: 2,
                  color: '#FFF3E1'
                }
              },
              axisLabel: {
                distance: -15,
                color: '#999',
                fontSize: 20,
                show: true,
                padding: [0, 0, 0, 0],
                formatter: function (value) {
                  if (value === 0) {
                    return ['{a|极高}'].join('\n')
                  } else if (value === 20) {
                    return ['{b|较高}'].join('\n')
                  } else if (value === 50) {
                    return ['{c|}', '{c|}', '{c|}', '{c|一般}'].join('\n')
                  } else if (value === 80) {
                    return ['{d|不错}'].join('\n')
                  } else if (value === 100) {
                    return ['{e|优秀}'].join('\n')
                  }
                },
                rich: {
                  a: {
                    fontWeight: 600,
                    fontSize: 14,
                    color: '#FF7E68',
                    align: 'left',
                    margin: 100
                  },
                  b: {
                    fontWeight: 600,
                    fontSize: 14,
                    color: '#FF9444',
                    align: 'center'
                  },
                  c: {
                    fontWeight: 600,
                    fontSize: 14,
                    color: '#FFC53D',
                    align: 'center',
                    lineHeight: '6'
                  },
                  d: {
                    fontWeight: 600,
                    fontSize: 14,
                    color: '#B0ED00',
                    align: 'center'
                  },
                  e: {
                    fontWeight: 600,
                    fontSize: 14,
                    color: '#00D679',
                    align: 'center',
                    margin: 100
                  }
                }
              },

              anchor: {
                show: false
              },
              title: {
                show: false
              },
              detail: {
                valueAnimation: true,
                width: '0',
                height: '0',
                borderRadius: 8,
                offsetCenter: [0, '-40%'],
                fontWeight: 'bolder',
                formatter: function (value) {
                  if (value <= 0) {
                    return ['{a|极高}', '{b|综合评价}'].join('\n')
                  } else if (value > 0 && value <= 25) {
                    return ['{a|较高}', '{b|综合评价}'].join('\n')
                  } else if (value > 25 && value <= 50) {
                    return ['{a|一般}', '{b|综合评价}'].join('\n')
                  } else if (value > 50 && value <= 75) {
                    return ['{a|不错}', '{b|综合评价}'].join('\n')
                  } else if (value > 75 && value <= 100) {
                    return ['{a|优秀}', '{b|综合评价}'].join('\n')
                  }
                },
                rich: {
                  a: {
                    fontSize: 20,
                    fontWeight: 'bold',
                    fontFamily: 'Arial',
                    lineHeight: 20,
                    margin: [250, 0, 0, 0],
                    color: '#202536',
                    align: 'center'
                  },
                  b: {
                    fontSize: 16,
                    fontWeight: 400,
                    fontFamily: 'Arial',
                    lineHeight: 30,
                    color: '#9497B1',
                    align: 'center'
                  }
                },
                backgroundColor: '#fff'
              },
              data: [
                {
                  value: value1
                }
              ]
            },
            {
              type: 'gauge',
              center: ['50%', '80%'],
              radius: '71%',
              startAngle: 180,
              animation: false,
              endAngle: 0,
              min: 0,
              max: 100,
              itemStyle: {
                color: '#fff'
              },
              progress: {
                show: true,
                width: 30
              },
              pointer: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              detail: {
                show: false
              },
              data: [
                {
                  value: value2
                }
              ]
            }
          ]
        }
        console.log(res, '初始化 getPremiumAndInsureNum折线图数据', option1, option2, 'option')
        console.log(result, value1, value2, '获取 风险分析')

        charts1.setOption(option1)
        charts2.setOption(option2)
        riskCharts.setOption(riskOption)
      }, 300)
    },

    //  查询公司安心日保余额
    async getInsureBalance() {
      const result = await getAxDailyBalanceApi({})

      console.log(result, ' 查询公司安心日保余额')
      this.balance = result.balance
    },
    // 获取银行账户信息
    async getBankAccountInfo() {
      const res: any = await getqueryreceiptaccountapi({ productType: 8 })
      this.bankInfo = {
        bankName: res.bankName,
        openBank: res.openBank,
        bankNo: res.bankNo
      }
    },
    // 获取当前项目id
    async getNowProjectId() {
      const res = await getNowProjectIdApi({
        platformCode: 1, //（1:PC B端  2:微信B端）
        insureType: 8 // 保险产品（ 2:长期保  8:安心日保）
      })
      this.projectId = res.projectId
      this.projectName = res.name
      console.log(res, '发起请求 获取当前项目id')
    },

    // 加保获取方案列表
    async getPlanList() {
      const result = await getInsureEnsurePlanApi({
        platformCode: 1, // 平台来源（1:PC B端  2:微信B端
        insureType: 8 // 保险产品（2:长期保 8:安心日保）
      })
      console.log('加保获取方案列表1111111111111111', result)
      this.planList = result.map((_) => {
        return {
          ..._,
          label: `${_.planName}`,
          value: _.planCode
        }
      })
      this.planSearchList = result.map((_) => {
        return {
          ..._,
          label: `${_.planName}`,
          value: _.companyPlanId
        }
      })
    },
    // 获取项目列表
    async getProjectList() {
      const res = await getEnsureProjectListApi({
        platformCode: 1, // 平台来源（1:PC B端  2:微信B端
        insureType: 8 // 保险产品（2:长期保 8:安心日保）
      })

      console.log('获取项目列表 获取项目列表 获取项目列表获取项目列表获取项目列表获取项目列表', res)

      this.projectList = res
    },

    // 选择方案后才可以选择派遣单位
    onPlanChange(planCode) {
      console.log(this.planList, planCode, '选择方案后')
      let obj = this.planList.find((_) => {
        return planCode == _.planCode
      })
      this.formAddInsure.companyId = ''
      this.formAddInsure.workType = ''
      this.getCompanyList(planCode, obj.code)
    },
    //  获取对应方案的 派遣单位
    async getCompanyList(planCode, code) {
      const res = await queryListByEnterApi({
        insureType: 8,
        planCode,
        insureCompany: code
      })
      console.log(res, '选择方案后 获取对应方案的 派遣单位')
      let arr = res.map((_) => {
        return {
          ..._,
          label: `${_.serveCompanyName}`,
          value: _.serveCompanyId
        }
      })
      this.companyList = arr.filter((_) => {
        return _.occupationList && _.occupationList.length
      })
    },
    // 选择派遣单位后 过滤工种
    onCompanyChange(id) {
      let obj = this.companyList.find((_) => {
        return id == _.value
      })
      this.formAddInsure.workType = ''
      this.workTypeList = obj.occupationList.map((_) => {
        return {
          ..._,
          label: `${_.occupationName}`,
          value: _.occupationId
        }
      })
    },

    // 获取实时数据
    async getRealTimeData() {
      const res: any = await getRealTimeDataApi({ insureType: 8 })

      console.log(res, Number(res.premiumPercent) * 100, Number(res.insureNumPercent) * 100, ' 获取实时数据')

      this.realTimeData = {
        premium: res.premium,
        premiumPercent: (Number(res.premiumPercent) * 100).toFixed(2),
        insureNum: res.insureNum,
        insureNumPercent: (Number(res.insureNumPercent) * 100).toFixed(2)
      }
    },
    // 当前投保人员-分页查询
    async initTableList() {
      console.log(2222, this.formSearch.policyStatus)
      const result = await queryStaffRecordListApi({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        projectId: this.projectId,
        searchUserInfo: this.formSearch.searchUserInfo,
        queryStartDate: this.formSearch.date[0],
        queryEndDate: this.formSearch.date[1],
        policyStatus: this.formSearch.policyStatus,
        companyPlanId: this.formSearch.planId
      })
      console.log(result, '当前投保人员-分页查询 ')

      this.tableData = result.list.map((_) => {
        return {
          ..._,
          cardNumShow: false,
          cardNumber: this.filterIdCard(_.idCardNo)
        }
      })
      this.total = result.totalCount
    },
    onChangCardId(row) {
      let index = this.tableData.findIndex((_) => {
        return _.id == row.id
      })

      console.log(row.id, index)
      this.tableData[index].cardNumShow = !row.cardNumShow
    },
    handleSelectionChangeOne(selects: any[]) {
      this.selects = selects.map((item) => item.id)
      this.renewalManufactory = selects.map((item) => {
        return {
          id: item.id, // 要换厂的人员列表id
          idCardNo: item.idCardNo, // 人员身份证
          occupationId: item.occupationId, // 工种id（客户要换厂的工种id）
          occupationName: item.occupationName, // 工种名（客户要换厂的工种名）
          serveCompanyId: item.serveCompanyId, // 被派遣单位id（要换厂的id）
          serveCompanyName: item.serveCompanyName, // 被派遣单位名称（要换厂的名称）
          userName: item.userName, // 用户名
          companyPlanId: item.companyPlanId
        }
      })
    },
    // 检查在保结束时间，如果是2099-01-01则显示"结案断保"
    checkInsureEndTime(insureEndTime: string) {
      if (!insureEndTime) return ''
      // 使用 dayjs 判断日期是否为 2099-01-01
      const endDate = dayjs(insureEndTime).format('YYYY-MM-DD')
      return endDate === '2099-01-01' ? '结案断保' : insureEndTime
    }
  }
})
